
export default class MdRadioListElement extends HTMLElement {
    constructor(){
        super();
    }
}

customElements.define('md-radio-list', MdRadioListElement);